import {mediaBreakpointDown} from "../utilities/MediaBreakpoints";

class Selector {
    static findAll(selector, element) {
        return element.querySelectorAll(selector);
    }

    static find(selector, element) {
        return element.querySelector(selector);
    }
}

class ScrollWatch {
    threshold = 350;

    constructor(navLinks, sections) {
        this.navLinks = navLinks;
        this.sections = sections;
        this.currentSection = -1;

        window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    handleScroll() {
        for (const entry of this.sections.values()) {
            if (entry.getBoundingClientRect().top <= this.threshold && entry.getBoundingClientRect().bottom >= this.threshold) {
                this.activateLink(entry);
                break;
            }
        }
    }

    activateLink(index) {
        if (index !== this.currentSection) {
            this.currentSection = index;
            for (const link of this.navLinks.values()) {
                if (this.currentSection.id === decodeURI(link.hash.slice(1))) {
                    link.classList.add('active');
                } else {
                    link.classList.remove('active');
                }
            }
        }
    }
}

export default class ScrollSpy {
    #rootElement;
    #target;
    #observableSections;
    #targetLinks;
    #observer;
    #previousScrollData;
    #activeTarget;
    #config;

    constructor(rootElement) {
        if (rootElement === null) return;
        this.#rootElement = rootElement;
        this.#target = document.querySelector(rootElement.getAttribute('data-spy-target'));
        this.#observableSections = new Map();
        this.#targetLinks = new Map();
        this.#previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        }
        this.#config = {
            rootMargin: this.#rootElement.getAttribute('data-spy-margin') !== null ? this.#rootElement.getAttribute('data-spy-margin') : '100px',
            threshold: [0.1, 0.5, 1]
        }
        this.main();
    }

    main() {
        this.setupObservables();
        this.setupMouseEvents();
        this.setupReaderURL();
        this.#observer = this.setupObserver();
        // for (const section of this.#observableSections.values()) {
        //     this.#observer.observe(section);
        // }
    }

    setupReaderURL() {
        const currentUrl = new URL(window.location);
        if (currentUrl.search) {
            const observableElement = document.querySelector(`[data-glossary-title="${decodeURI(currentUrl.searchParams.get('index'))}"]`);
            if (observableElement === null) return;
            const height = observableElement.offsetTop - this.#rootElement.offsetTop - this.rootOffsetTop;
            setTimeout(() => {
                window.scrollTo({top: height, behavior: 'smooth'})
            }, 500);
        }
    }

    setupObservables() {
        for (const target of this.target.querySelectorAll('.observable')) {
            if (!target.hash) {
                continue;
            }

            const foundSection = Selector.find(decodeURI(target.hash), this.#rootElement);
            if (this.#rootElement !== null) {
                this.#observableSections.set(decodeURI(target.hash), foundSection);
                this.#targetLinks.set(decodeURI(target.hash), target);
            }
        }
    }

    setupMouseEvents() {
        for (const [id, element] of this.#targetLinks.entries()) {
            element.addEventListener('click', (event) => {
                const observableSection = this.#observableSections.get(decodeURI(event.target.hash));
                if (observableSection) {
                    event.preventDefault();
                    const root = window;
                    const height = observableSection.offsetTop - this.#rootElement.offsetTop - this.rootOffsetTop;
                    root.scrollTo({top: height, behavior: 'smooth'});
                }
            })
        }
    }

    #clearActiveClass(targetContainer) {
        targetContainer.classList.remove('active');
        const activeNodes = Selector.findAll('.active', targetContainer);
        for (const activeNode of activeNodes) {
            activeNode.classList.remove('active');
        }
    }

    #process(target) {
        if (this.#activeTarget === target) {
            return
        }
        this.#clearActiveClass(this.#target)
        this.#activeTarget = target;
        target.classList.add('active');
    }


    #observerCallback(entries) {
        const targetElement = entry => this.#targetLinks.get(`#${entry.target.id}`);
        const activate = entry => {
            this.#previousScrollData.visibleEntryTop = entry.target.offsetTop
            this.#process(targetElement(entry));
        }
        // todo: decrement of "this.#rootElement.offsetTop" must be evaluated later on, works for now
        // const parentScrollTop = document.documentElement.scrollTop - this.#rootElement.offsetTop;
        const parentScrollTop = document.documentElement.scrollTop;
        const userScrollsDown = parentScrollTop >= this.#previousScrollData.parentScrollTop
        this.#previousScrollData.parentScrollTop = parentScrollTop

        for (const entry of entries) {
            // console.log(entry);
            // if (!entry.isIntersecting) {
            //     this.#activeTarget = null;
            //     this.#clearActiveClass(targetElement(entry));
            //
            //     continue;
            // }
            // const entryIsLowerThanPrevious = entry.target.offsetTop >= this.#previousScrollData.visibleEntryTop;
            // if (entry.target.offsetTop < 100) {
            //     activate(entry);
            // }
            // if we are scrolling down, pick the bigger offsetTop
            // if (userScrollsDown && entryIsLowerThanPrevious) {
            //     console.log(entry);
            //     activate(entry)
            //     // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
            //     if (!parentScrollTop) {
            //         return
            //     }
            //     continue;
            // }
            //
            // // if we are scrolling up, pick the smallest offsetTop
            // if (!userScrollsDown && !entryIsLowerThanPrevious) {
            //     activate(entry)
            // }
        }

    }

    setupObserver() {
        return new ScrollWatch(this.#targetLinks, this.#observableSections);

        // const options = {
        //     root: null,
        //     threshold: this.#config.threshold,
        //     rootMargin: `${this.#config.rootMargin}px`
        // }
        //
        // return new IntersectionObserver(entries => this.#observerCallback(entries), options)
    }

    get target() {
        return this.#target;
    }

    set target(value) {
        this.#target = value;
    }

    get rootOffsetTop() {
        return mediaBreakpointDown('lg') ? 0 : 85;
    }
}
